import type { RefObject } from 'react';
import { useEffect, useRef } from 'react';

import { usePromotePageState } from 'src/app/pages/promote/pageContext';

type Result = ModelHookResult<{
	ref: RefObject<HTMLDivElement | null>;
}>;

export function useImpressionAmountSelector(): Result {
	const [{ validationErrors }] = usePromotePageState();

	const ref = useRef<HTMLDivElement | null>(null);

	useEffect(() => {
		if (ref.current && validationErrors?.amount) ref.current.scrollIntoView();
	}, [validationErrors?.amount, ref]);

	return {
		data: {
			ref,
		},
	};
}
